export default __webpack_public_path__ + "static/media/080_finish_good.last.ab00c84f.png";